/**
 * 淘客选择CMS的所有网站入口配置文件
 */

import { isArray } from 'core-js/fn/array'
import merge from 'merge'
import store from '@/store'
import { pingku_items_list, pingku_items_info } from '@/api/pkEdit.js'

/**
 * 数据对象
 * @property {string} plugin_name 插件过期时间（单位：秒，与当前时间比较，大于当前时间则为有效插件），用于显示某些权限入口
 * @property {array} version_exclude 淘客购买的cms版本，如果当前版本包含在数组内，则代表版本权限不够
 */
const maps = {
  plate: {
    title: '板块',
    type: 'plate',
    tag: 'radio',
    list: [
      { label: '首页', url: '/' },
      { label: '爆款排行', url: '/ranking' },
      { label: '人工精选', url: '/channel/1' },
      { label: '9块9', url: '/channel/0' },
      { label: '全部分类', url: '/category' },
      { label: '淘抢购', url: '/category/tag_0' },
      { label: '聚划算', url: '/category/tag_1' },
      { label: '视频', url: '/category/tag_3' },
      { label: '天猫赠品', url: '/category/tag_4' },
      { label: '万人好评', url: '/category/mama_channel_1' },
      { label: '清仓好货', url: '/category/mama_channel_2' },
      { label: '品牌爆品', url: '/category/mama_channel_3' },
      { label: '女装', url: '/category/10' },
      { label: '男装', url: '/category/20' },
      { label: '鞋类', url: '/category/210' },
      { label: '内衣', url: '/category/40' },
      { label: '母婴', url: '/category/50' },
      { label: '美妆', url: '/category/60' },
      { label: '箱包', url: '/category/70' },
      { label: '居家', url: '/category/80' },
      { label: '家装', url: '/category/90' },
      { label: '配饰', url: '/category/100' },
      { label: '美食', url: '/category/110' },
      { label: '文娱', url: '/category/120' },
      { label: '车品', url: '/category/130' },
      { label: '户外运动', url: '/category/140' },
      { label: '数码家电', url: '/category/150' },
      { label: '宠物绿植', url: '/category/160' },
      { label: '保健成人', url: '/category/170' },
      { label: '其它', url: '/category/990' },
      { label: '帮助中心', url: '/help' },
      { label: '京东商城', url: '/jdList' },
      { label: '拼多多商城', url: '/pddList', disabled: true },
      { label: '联系客服', url: '/kf' },
    ],
  },

  single: {
    title: '单品',
    type: 'single',
    tag: 'input',
    input: {
      placeholder: '请填写淘宝id',
    },
  },

  external: {
    title: '站外链接',
    type: 'external',
    tag: 'input',
    input: {
      placeholder: '请填写站外链接',
    },
  },

  user: {
    title: '个人中心',
    type: 'user',
    tag: 'radio',
    version_exclude: [0, 1],
    list: [
      { label: '个人中心', url: '/user', version_exclude: [0, 1], disabled: true },
      { label: '佣金明细', url: '/user/balance', version_exclude: [0, 1], disabled: true },
      { label: '订单', url: '/order?active=1', version_exclude: [0, 1], disabled: true },
      { label: '邀请注册', url: '/invitation', version_exclude: [0, 1], disabled: true },
      { label: '粉丝', url: '/fans', version_exclude: [0, 1], disabled: true },
      { label: '分销订单', url: '/fans/order', version_exclude: [0, 1], disabled: true },
      { label: '找回订单', url: '/order/find', version_exclude: [0, 1], disabled: true },
      { label: '申请成为代理', url: '/request', version_exclude: [0, 1], disabled: true },
    ],
  },

  plugin: {
    title: '拓展功能',
    type: 'plugin',
    tag: 'radio',
    list: [
      { label: '0元购', url: '/lyg', plugin_name: 'plugin_lyg_expires_at', disabled: true },
      { label: '官方红包', url: '#gfhb#', plugin_name: 'plugin_gfhb_expires_at', disabled: true },
      { label: '超级秒杀', url: '/xsms', plugin_name: 'plugin_xsms_expires_at', disabled: true },
      { label: '提现红包', url: '/redpack', plugin_name: 'plugin_txhb_expires_at', disabled: true },
      { label: '签到', url: '/checkin', plugin_name: 'plugin_checkin_expires_at', disabled: true },
      { label: '限时抢购', url: '/flashsale', plugin_name: 'plugin_flashsale_expires_at', disabled: true },
      { label: '外卖优惠', url: '/food', version_exclude: [0, 1], disabled: true },
      { label: '打车优惠', url: '/taxi'},
    ],
  },
}

// 排序
const order = [ 'plate', 'single', 'external', 'user', 'plugin' ]

// 数据数组
const dataList = order.map((key) => maps[key])

// 所有单选框的数据数组（有区分type）
const radioDataList = dataList.filter((item) => item.tag === 'radio')

// radio数组转换为键值对
const radioMaps = {}
radioDataList.forEach((item) => {
  item.list.forEach((sub) => {
    radioMaps[sub.label] = sub
    radioMaps[sub.url] = sub
  })
})

/**
 * 查找单选框对应的内容
 *
 * @param {string} value 单选框的label或url
 * @param {string} [type] 数据的类型，可以增加查询效率 [plate, signle, external, user]
 * @param {string} [dataList] 通过getDataList获取的数据列表，推荐传入
 */
export function findRadioItem(value, type, dataList) {
  if (!value) return null

  // 重载：findRadioItem(value, dataList)
  if (typeof type !== 'string' && !dataList) {
    dataList = type
    type = undefined
  }
  if (!maps[type]) type = undefined

  // 需要查询的数据集
  let datas = null
  if (type) {
    datas = [maps[type]]
  } else {
    const _radioDataList = dataList ? dataList.filter((item) => item.tag === 'radio') : radioDataList
    datas = _radioDataList
  }

  let radio = null
  // 找出value对应的单选项
  const group = datas.find(({ list }) => {
    radio = list.find((item) => value === item.label || value === item.url)
    return !!radio
  })

  if (!group || !radio) return null

  return {
    label: radio.label,
    url: radio.url,
    type: group.type,
  }
}


/**
 * 单品获取指定id
 * @param {number} id 商品id，可以是品库id和淘宝id
 * @param {string} [resultType] 需要返回的id，[tb, pk]
 */
async function singleGetID(id, resultType) {
  let tbID = ''
  let pkID = ''

  // 先做为淘宝id进行搜索
  const res = await pingku_items_list({ q: id, pagesize: 1 })
  const list = res.data.list || []
  if (list.length) {
    const info = list[0]
    tbID = id
    pkID = info.id
  } else { // 将id做为品库id查询
    const { data } = await pingku_items_info({ id })
    const { info } = data
    if (info) {
      tbID = info.item_id
      pkID = id
    }
  }

  if (['tb', 'pk'].includes(resultType) === false) {
    return { tbID, pkID }
  } else {
    return resultType === 'pk' ? pkID : tbID
  }
}

// 判断是否是单品
function isSingle(value, domain) {
  value = value.replace(domain, '').replace('/goods/', '')
  return isNaN(value - 0) === false
}
// 判断是否是单选框的内容
function isRadio(value, domain, dataList) {
  value = value.replace(domain, '')
  const radio = findRadioItem(value, dataList)
  return radio || false
}

/**
 * 根据输入的数据解析出数据的tag和值
 * @param {string} value 用户输入的数据 或 单选框选中的数据(label、name)
 * @param {Array} dataList 通过getDataList获取的数据列表
 */
export async function valueParse(value, dataList) {
  if (!dataList) return null

  if (!value) {
    return { type: 'plate' }
  }

  const { domain, ssl } = store.state.cmsInfo.info
  const fullDomain = `http${ssl ? 's' : ''}://${domain}/#`
  const cpValue = value.replace(fullDomain, '')

  // 单品（value = '/goods/:id' 或 ':id'）
  if (isSingle(value, fullDomain)) {
    const id = await singleGetID(cpValue.replace('/goods/', ''), 'tb')
    return {
      type: 'single',
      value: id,
    }
  }

  // 单选框item
  const radio = isRadio(value, fullDomain, dataList)
  if (radio) {
    return {
      type: radio.type,
      value: radio,
    }
  }

  // 其余情况算是外链
  return {
    type: 'external',
    value: cpValue,
  }
}


/**
 * 校验 value 是否可以被显示(禁用)
 * @param {string} value 任意字符串内容，匹配不到将会返回true
 */
export function validateAuthority(value) {
  const item = radioMaps[value] || null
  if (!item) return true

  const { plugin_name, version_exclude } = item

  // 不需要权限
  if (!plugin_name && !version_exclude) {
    return true
  }

  let canUsePlugin = true
  let canUseVip = true

  // 插件权限
  if (plugin_name) {
    const cms = store.state.cmsInfo.info
    const pluginEndTime = cms[plugin_name] || 0
    const now = parseInt(Date.now() / 1000)
    canUsePlugin = now < pluginEndTime
  }

  // cms版本权限
  if (version_exclude) {
    const vip = store.state.user.info.vip - 0
    canUseVip = version_exclude.includes(vip) === false
  }

  return canUsePlugin && canUseVip
}

/**
 * 校验 value 是否可以被显示(禁用)
 * @param {array<object>} array 对象数组，对象中必须包含 href_title 字段
 */
function filterAuthority(array) {
  return array.filter((item) => {
    return validateAuthority(item.href_title)
  })
}


/**
 * 获取数据列表 会过滤掉所有未购买的插件
 */
export function getDataList() {
  const vip = store.state.user.info.vip - 0
  const cms = store.state.cmsInfo.info

  const groupList = order.map((key) => maps[key]) // 按照排序转成数组
  // .filter(item => { // tab item 的cms 版本比较
  //   const { version_exclude } = item
  //   if (version_exclude && vip === undefined) return false
  //   if (version_exclude) return version_exclude.includes(vip - 0) === false
  //   return true
  // })

  const newList = groupList.map((group) => {
    // 深拷贝对象
    group = merge.recursive(true, group)

    // radio 校验插件权限，过期或没买的不允许点击
    const list = group.list
    if (group.tag === 'radio' && isArray(list) && list.length > 0) {
      list.forEach((radio) => {
        let disabledPlugin = true
        let disabledVip = true

        // 插件
        if (radio.plugin_name) {
          const pluginEndTime = cms[radio.plugin_name] || 0
          const now = parseInt(Date.now() / 1000)
          disabledPlugin = now >= pluginEndTime // 是否过期
        }
        // cms版本
        if (radio.version_exclude) {
          disabledVip = radio.version_exclude.includes(vip)
        }
        if (radio.plugin_name || radio.version_exclude) {
          radio.disabled = disabledPlugin && disabledVip
        }
      })

      // 排序，可用的radio在前面
      // group.list = list.sort((a, b) => {

      //   // if (a.disabled)

      //   // if (b.disabled === undefined) {
      //   //   return -1
      //   // }
      //   // if (b.disabled === false) {
      //   //   return 0
      //   // }
      //   // return 1
      //   // return a.disabled === false ? -1 : 0
      // })
    }

    return group
  })

  return newList
}

export default {
  getDataList,
  findRadioItem,
  valueParse,
  validateAuthority,
  singleGetID,
  filterAuthority,
}
